var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hotspotCutout" },
    [
      _vm.datas.imageList && _vm.datas.imageList.length > 0
        ? _c(
            "div",
            { staticClass: "stack-wrapper" },
            _vm._l(_vm.datas.imageList, function (img, index) {
              return img.url
                ? _c("img", {
                    key: index,
                    staticClass: "stack-img",
                    style: _vm.imgStyleObj,
                    attrs: {
                      src: _vm.resPath + img.url,
                      alt: img.title || "热区切图",
                    },
                  })
                : _vm._e()
            }),
            0
          )
        : _c("div", { staticClass: "stack-placeholder" }, [
            _c("i", { staticClass: "el-icon-picture-outline default-icon" }),
            _vm._v(" "),
            _c("p", [_vm._v("暂无热区图片")]),
          ]),
      _vm._v(" "),
      _vm._t("deles"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }